import type { LucideProps } from 'lucide-react'

export const ArrowRight = (props: LucideProps) => {
	return (
		<svg
			width="24"
			height="24"
			viewBox="0 0 24 24"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
			{...props}
		>
			<title>Arrow point right</title>
			<path
				d="M12.192 7.17303L19.788 12L12.192 16.827L12.192 12.5L3.07696 12.5L3.07696 11.5L12.192 11.5L12.192 7.17303Z"
				fill="currentColor"
			/>
		</svg>
	)
}
